import { createRoot } from 'react-dom/client';

import '@/i18n';
import '@assets/tailwind.css';

import { App } from '@/App';

createRoot(document.getElementById('root')!).render(<App />);
